{
  "schemaVersion": "cogo.application-blueprint.v1",
  "applicationBlueprintId": "newsletter-membership",
  "version": "1.0.0",
  "applicationCoreRef": "cogo:application-core/newsletter-membership-v1",
  "target": "web",
  "locale": "en-US",
  "recipeRef": "cogo:composition-recipe/newsletter-membership-v1",
  "userGoal": "Run a two-audience newsletter membership",
  "actor": "newsletter-operator",
  "capabilities": [
    "join-membership",
    "update-membership-draft",
    "open-member-content",
    "select-operator-member",
    "edit-operator-change-draft",
    "preview-content-impact",
    "apply-operator-change",
    "read-membership-roster",
    "read-content-items"
  ],
  "applicationStates": ["draft", "previewed", "published"],
  "applicationEvents": [
    "membership-draft-updated",
    "membership-joined",
    "member-content-opened",
    "operator-member-selected",
    "operator-change-draft-edited",
    "content-impact-previewed",
    "operator-change-applied"
  ],
  "applicationFlows": [
    { "flowId": "coordinate-membership-draft", "eventRef": "membership-draft-updated", "capabilityRef": "update-membership-draft" },
    { "flowId": "coordinate-membership-join", "eventRef": "membership-joined", "capabilityRef": "join-membership" },
    { "flowId": "coordinate-member-content-open", "eventRef": "member-content-opened", "capabilityRef": "open-member-content" },
    { "flowId": "coordinate-operator-member-select", "eventRef": "operator-member-selected", "capabilityRef": "select-operator-member" },
    { "flowId": "coordinate-operator-change-draft", "eventRef": "operator-change-draft-edited", "capabilityRef": "edit-operator-change-draft" },
    { "flowId": "coordinate-content-impact-preview", "eventRef": "content-impact-previewed", "capabilityRef": "preview-content-impact" },
    { "flowId": "coordinate-operator-change-apply", "eventRef": "operator-change-applied", "capabilityRef": "apply-operator-change" }
  ],
  "datasourceRequirements": [
    { "datasourceId": "members", "capabilityRef": "read-membership-roster" },
    { "datasourceId": "content-items", "capabilityRef": "read-content-items" },
    { "datasourceId": "membership-draft", "capabilityRef": "update-membership-draft" },
    { "datasourceId": "operator-change-draft", "capabilityRef": "edit-operator-change-draft" }
  ],
  "applicationPorts": [
    { "portId": "membership-draft-updated", "kind": "event", "direction": "in", "valueType": "cogo.membership-draft", "required": true },
    { "portId": "membership-joined", "kind": "event", "direction": "in", "valueType": "cogo.member-id", "required": true },
    { "portId": "member-content-opened", "kind": "event", "direction": "in", "valueType": "cogo.content-item-id", "required": true },
    { "portId": "operator-member-selected", "kind": "event", "direction": "in", "valueType": "cogo.member-id", "required": true },
    { "portId": "operator-change-draft-edited", "kind": "event", "direction": "in", "valueType": "cogo.operator-change-draft", "required": true },
    { "portId": "content-impact-previewed", "kind": "event", "direction": "in", "valueType": "cogo.change-impact", "required": true },
    { "portId": "operator-change-applied", "kind": "event", "direction": "in", "valueType": "cogo.change-impact", "required": true }
  ],
  "uxInstances": [
    { "uxInstanceId": "membership-signup", "definitionRef": "newsletter-membership-signup@1.0.0" },
    { "uxInstanceId": "member-content", "definitionRef": "newsletter-member-content@1.0.0" },
    { "uxInstanceId": "operator-overview", "definitionRef": "newsletter-operator-overview@1.0.0" },
    { "uxInstanceId": "operator-impact-controls", "definitionRef": "newsletter-operator-impact-controls@1.0.0" }
  ],
  "bindings": [
    {
      "bindingId": "membership-draft-updated",
      "source": { "scope": "ux-instance", "uxInstanceId": "membership-signup", "portId": "membership-draft-updated" },
      "target": { "scope": "application", "portId": "membership-draft-updated" }
    },
    {
      "bindingId": "membership-joined",
      "source": { "scope": "ux-instance", "uxInstanceId": "membership-signup", "portId": "membership-joined" },
      "target": { "scope": "application", "portId": "membership-joined" }
    },
    {
      "bindingId": "member-content-opened",
      "source": { "scope": "ux-instance", "uxInstanceId": "member-content", "portId": "member-content-opened" },
      "target": { "scope": "application", "portId": "member-content-opened" }
    },
    {
      "bindingId": "operator-member-selected",
      "source": { "scope": "ux-instance", "uxInstanceId": "operator-overview", "portId": "operator-member-selected" },
      "target": { "scope": "application", "portId": "operator-member-selected" }
    },
    {
      "bindingId": "operator-change-draft-edited",
      "source": { "scope": "ux-instance", "uxInstanceId": "operator-impact-controls", "portId": "operator-change-draft-edited" },
      "target": { "scope": "application", "portId": "operator-change-draft-edited" }
    },
    {
      "bindingId": "content-impact-previewed",
      "source": { "scope": "ux-instance", "uxInstanceId": "operator-impact-controls", "portId": "content-impact-previewed" },
      "target": { "scope": "application", "portId": "content-impact-previewed" }
    },
    {
      "bindingId": "operator-change-applied",
      "source": { "scope": "ux-instance", "uxInstanceId": "operator-impact-controls", "portId": "operator-change-applied" },
      "target": { "scope": "application", "portId": "operator-change-applied" }
    }
  ],
  "journey": {
    "entryStepId": "join-membership",
    "terminalStepIds": ["change-applied"],
    "steps": [
      {
        "stepId": "join-membership",
        "uxInstanceIds": ["membership-signup"],
        "transitions": [
          { "eventRef": "membership-draft-updated", "toStepId": "join-membership", "path": "forward" },
          { "eventRef": "membership-joined", "toStepId": "read-member-content", "path": "forward" }
        ]
      },
      {
        "stepId": "read-member-content",
        "uxInstanceIds": ["member-content"],
        "transitions": [
          { "eventRef": "member-content-opened", "toStepId": "review-membership", "path": "forward" }
        ]
      },
      {
        "stepId": "review-membership",
        "uxInstanceIds": ["operator-overview"],
        "transitions": [
          { "eventRef": "operator-member-selected", "toStepId": "adjust-content-access", "path": "forward" }
        ]
      },
      {
        "stepId": "adjust-content-access",
        "uxInstanceIds": ["operator-impact-controls"],
        "transitions": [
          { "eventRef": "operator-change-draft-edited", "toStepId": "adjust-content-access", "path": "forward" },
          { "eventRef": "content-impact-previewed", "toStepId": "confirm-change", "path": "forward" }
        ]
      },
      {
        "stepId": "confirm-change",
        "uxInstanceIds": ["operator-impact-controls"],
        "transitions": [
          { "eventRef": "operator-change-applied", "toStepId": "change-applied", "path": "forward" }
        ]
      },
      { "stepId": "change-applied", "uxInstanceIds": [], "transitions": [] }
    ]
  },
  "lineage": {
    "authorityStatus": "consumer-verified",
    "sourceKind": "application-core",
    "sourceRefs": ["cogo:application-core/newsletter-membership-v1"]
  },
  "runtimeCapabilities": {
    "webMcp": { "mode": "disabled", "toolRefs": [], "approvalPolicyRef": null }
  }
}
